var base = require('settings/teams/glide-integration');

Vue.component('spark-glide-integration', {
    mixins: [base]
});
